import React, { Fragment, useState } from 'react';
import { Route, Routes } from "react-router-dom";

import { PAGE_URL } from '../../../value/Url';

import ContentsProps from '../../../interfaceTypes/ContentsProps';
import AccountMgmtContainer from './AccountMgmtContainer';
import AccountDetailContainer from './AccountDetailContainer';
import AccountChangePwdContainer from './AccountChangePwdContainer';





export default function AccountPage(props:ContentsProps) {
    const [detailId, setDetailId] = useState('');

    function moveDetail(targetId) {
        setDetailId(targetId);
    }

    return (
        <Fragment>
            <Routes>
                <Route path={`/`} element={<AccountMgmtContainer setLoading={props.setLoading} showSlideModalCb={props.showSlideModalCb} showPopupModalCb={props.showPopupModalCb} moveDetailCb={moveDetail}/>} />
                <Route path={`/${PAGE_URL.DETAIL_MANAGEMENT}`} element={<AccountDetailContainer setLoading={props.setLoading} showSlideModalCb={props.showSlideModalCb} showPopupModalCb={props.showPopupModalCb} targetId={detailId}/>} />
                <Route path={`/${PAGE_URL.CHANGEPWD}`} element={<AccountChangePwdContainer setLoading={props.setLoading} showSlideModalCb={props.showSlideModalCb} showPopupModalCb={props.showPopupModalCb}/>} />
            </Routes>
        </Fragment>
    )
}